import { React } from 'react';
import styled from 'styled-components';

import SearchImage from '../../image/SearchImage.png';

export default function SearchInput(props) {
  const { value, setValue, placeholder } = props;

  function handleChange(e) {
    setValue(e.target.value);
  }

  return (
    <TopLevelWrapper>
      <Icon src={SearchImage}/>
      <Input
        value={value}
        onChange={handleChange}
        placeholder={placeholder} />
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
	height: 32px;

  border-radius: 16px;
  background-color: #F2F2F2;
`;

const Icon = styled.img`
  margin: 0px 8px 0px 8px;

  width: 24px;
  height: 24px;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;

	outline: none;
	border: 0px;
  color: #232323;

	width: 320px;
	height: 100%;

  background-color: transparent;

	::placeholder {
		color: #CBCBCB;
	}
`;